<template>
  <div class="social-auth _py-6 _px-4 _bg-light" v-if="Links && Links.length">
    <div class="social-auth__text _mr-auto">
      <div class="_fs-20 _lh-24 _tc-dark _fw-700">
        {{ $t('modals.social.title') }}
      </div>
      <div class="_fs-16 _lh-24 _tc-dark-grey">
        {{ $t('modals.social.title2') }}
      </div>
    </div>
    <div class="social-auth__socials _mt-sm-4">
      <div
        class="social-auth__item"
        :class="link.provider"
        :href="link.link"
        @click="dataLayerPush(link.provider, link.link)"
        v-for="(link, i) in Links"
        :key="i"
      >
        <img :src="require(`@/assets/img/icons/${link.provider}.svg`)" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'socialAuth',
  computed: {
    ...mapGetters(['Links']),
    providers() {
      return {
        'vk.com': 'vk',
        'ok.ru': 'ok',
        't.me': 'tg',
      }
    },
  },
  methods: {
    ...mapActions(['fetchSocialLinks']),
    dataLayerPush(txt, path) {
      if (this.$gtm) {
        this.$gtm.push({
          event: 'auth_click',
          param_value: this.providers[txt],
        })
      }
      localStorage.setItem('auth_type', this.providers[txt])
      window.open(path, '_self')
    },
  },
  async mounted() {
    await this.fetchSocialLinks()
  },
}
</script>

<style lang="scss" scoped>
.social-auth {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 16px;

  @media screen and (max-width: 743px) {
    flex-direction: column;
    align-items: flex-start;
  }

  &__socials {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__item {
    width: 38px;
    height: 38px;
    border-radius: 16px;
    background-color: color(white);
    margin-right: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
